export const dataObject = [
  {
    value: 'Object',
    label: 'Shape',
    color: 'pink',
  },
  {
    value: 'Material',
    label: 'Material',
    color: 'grape',
  },
];

export const dataScene = [
  {
    value: 'Scene',
    label: 'Scene',
    color: 'blue',
  },
  {
    value: 'Live',
    label: 'Live',
    color: 'pink',
  },
];
